import { Button, Stack, ThemeProvider, Typography } from '@mui/material';
import EmptyBoxImage from '../../assets/images/empty-data-image.svg';
import { newVyTheme } from '../../assets/themes/new-vy-theme';
import { useVyNavigate } from '../../hooks/use-vy-navigate';

export const NotFoundPage = () => {
  const navigate = useVyNavigate();

  return (
    <ThemeProvider theme={newVyTheme}>
      <Stack
        height="100%"
        alignItems="center"
        justifyContent="center"
        rowGap={2}
      >
        <img
          src={EmptyBoxImage}
          alt="Empty notifications"
          className="mx-auto w-[300px] h-[300px] mb-[-50px] no-select"
        />
        <Typography
          variant="h6"
          align="center"
        >
          Something Went Wrong
        </Typography>

        <Button
          size="large"
          variant="outlined"
          onClick={() => navigate(-1)}
        >
          Go back
        </Button>
      </Stack>
    </ThemeProvider>
  );
};